import { usePageTitle } from "../../custom-hooks";

const NotFound=()=>{
    usePageTitle('Travel Tape | NotFound');

    return(
        <div>NotFound</div>
    )
}
export {NotFound};